import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedService } from '@services/shared.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-accept-givi-modal',
    templateUrl: './accept-givi-modal.component.html',
    styleUrls: ['./accept-givi-modal.component.scss']
})
export class AcceptGiviModalComponent implements OnInit {

    @Input() productName: string = '';
    @Input() productImage: string = '';

    @Input() points: number;
    
    @Output() acceptGivi: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('showModalAcceptGivi', { static: true }) modal: any;

    showAcceptGiviModalSubscription: Subscription = null;

    constructor(private modalService: NgbModal, private router: Router,public sharedService: SharedService) { }

    ngOnInit(): void {

        this.showAcceptGiviModalSubscription = this.sharedService.showAcceptGiviModal.subscribe(show => {
            if (show) this.openModal();
        });
    }

    ngOnDestroy(): void {

        if (this.showAcceptGiviModalSubscription) { this.showAcceptGiviModalSubscription.unsubscribe(); }
    }

    openModal() {

        this.modalService.open(this.modal, {
            backdrop: 'static', keyboard: false,
            size: 'lg', centered: true, windowClass: 'modal-full'
        });
    }

    acceptMyGivi() {

        this.acceptGivi.next(true);
        this.modalService.dismissAll();
    }

    closeModal() {
        
        this.acceptGivi.next(false);
        this.modalService.dismissAll();
    }
}
